import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIResponse, CityResponse } from '@app/core.model';
import { CommonService } from '@app/services/common.service';
import { environment } from 'src/environments/environment';
import {
  ClinicResponse,
  ClinicPayload,
  HealthCareCategoryResponse,
  MappedClincResponse,
  ClinicDetailResponse,
  ClinicLetterheadPayload,
  PrescriptionPdfAssetsPayload,
  SubStoreResponse,
  SubStorePayload,
} from './managed-clinic.model';
import { SharedMastersService } from '@app/services/sharedMasters.service';

@Injectable({
  providedIn: 'root',
})
export class ManagedClinicService {
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private sharedMasterService: SharedMastersService
  ) {}
  addRoom(
    clinic_id: string,
    roomList: Array<{ name: string; weight: number }>
  ) {
    return this.http.post<APIResponse>(
      `${environment.baseAPIUrl}/clinics/${clinic_id}/rooms`,
      { rooms: roomList },
      {
        headers: this.commonService.getRequestHeaders(),
      }
    );
  }
  getCityListById(id: string, filter?: string) {
    let url = `${environment.baseAPIUrl}/masters/states/${id}/cities`;
    if (filter?.length) {
      url += `filter=${filter}`;
    }
    return this.http.get<CityResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }
  addClinic(payload: ClinicPayload) {
    return this.http.post<APIResponse>(
      `${environment.baseAPIUrl}/clinics`,
      payload,
      {
        headers: this.commonService.getRequestHeaders(),
      }
    );
  }
  updateClinic(payload: ClinicPayload, id: string) {
    return this.http.put<APIResponse>(
      `${environment.baseAPIUrl}/clinics/${id}`,
      payload,
      {
        headers: this.commonService.getRequestHeaders(),
      }
    );
  }
  deleteRoom(clinic_id: string, roomList: Array<string>) {
    return this.http.delete<APIResponse>(
      `${environment.baseAPIUrl}/clinics/${clinic_id}/rooms`,
      {
        headers: this.commonService.getRequestHeaders(),
        body: { roomIds: roomList },
      }
    );
  }
  getStateList(filter?: string) {
    return this.sharedMasterService.getStateList(filter);
  }

  getClinicList() {
    let url = `${environment.baseAPIUrl}/v2/clinics`;
    return this.http.get<ClinicResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }
  getCityList(filter?: string) {
    return this.sharedMasterService.getCityList(filter);
  }

  getCategoryList() {
    const url = `${environment.baseAPIUrl}/health-care-services/categories?sortBy=category_name`;
    return this.http.get<HealthCareCategoryResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }
  getMappedClinicService(clinic_id: string) {
    const url = `${environment.baseAPIUrl}/clinic-services/clinics/${clinic_id}`;
    return this.http.get<MappedClincResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  mapServicesToClinic(payload: { clinicId: string; serviceIds: string[] }) {
    const url = `${environment.baseAPIUrl}/clinic-services`;
    return this.http.post(url, payload, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getClinicDetail(clinicId: string) {
    const url = `${environment.baseAPIUrl}/clinics/${clinicId}`;
    return this.http.get<ClinicDetailResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  saveClinicLetterhead(clinicId: string, payload: ClinicLetterheadPayload) {
    const url = `${environment.baseAPIUrl}/clinics/${clinicId}/letterhead`;
    return this.http.post<APIResponse>(url, payload, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  savePrescriptionPdfAssets(
    clinicId: string,
    payload: PrescriptionPdfAssetsPayload
  ) {
    const url = `${environment.baseAPIUrl}/clinics/${clinicId}/prescription-pdf-assets`;
    return this.http.put<APIResponse>(url, payload, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  getSubStores(clinicId: string, filter?: string) {
    let url = `${environment.baseAPIUrl}/clinics/${clinicId}/substores`;
    if (filter) {
      url += `?filter=${filter}`;
    }
    return this.http.get<SubStoreResponse>(url, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  addSubStore(clinicId: string, payload: SubStorePayload) {
    const url = `${environment.baseAPIUrl}/clinics/${clinicId}/substores`;
    return this.http.post<APIResponse>(url, payload, {
      headers: this.commonService.getRequestHeaders(),
    });
  }

  updateSubStore(
    clinicId: string,
    subStoreId: string,
    payload: SubStorePayload
  ) {
    const url = `${environment.baseAPIUrl}/clinics/${clinicId}/substores/${subStoreId}`;
    return this.http.patch<APIResponse>(url, payload, {
      headers: this.commonService.getRequestHeaders(),
    });
  }
}

